import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Error404Component } from './error404/error404.component';

const routes: Routes = [
  { path: 'home',
    pathMatch: 'full',
    redirectTo: ''
  },
  { path:'',
    loadChildren: () => import('./Home/home.module').then(m => m.HomeModule)
  },
  { path:'about',
    loadChildren: () => import('./About/about.module').then(m => m.AboutModule)
  },
  { path:'expertise',
    loadChildren: () => import('./Expertise/expertise.module').then(m => m.ExpertiseModule) 
  },
  { path:'products',
    loadChildren: () => import('./Products/products.module').then(m => m.ProductsModule) 
  },
  { path:'contact',
    loadChildren: () => import('./Contact/contact.module').then(m => m.ContactModule)
  },
  {path:'**',pathMatch:'full',component:Error404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
